import { ReactNode } from "react";
import { ExternalToast, toast } from "sonner";

export const customToast = {
  success: (message: string, data?: ExternalToast, id?: string): ReactNode =>
    toast.success(message, {
      id: id ?? message,
      ...data,
    }),

  error: (message: string, data?: ExternalToast): ReactNode =>
    toast.error(message, {
      id: message,
      ...data,
    }),

  warn: (message: string, data?: ExternalToast): ReactNode =>
    toast.warning(message, {
      id: message,
      ...data,
    }),

  info: (message: string, data?: ExternalToast): ReactNode =>
    toast.info(message, {
      id: message,
      ...data,
    }),
};
